import React__default from 'react';
import { ProductTag } from '../../../components/ProductTag/ProductTag.js';
import { PrescriptionAvailabilityTagContainer } from '../../../components/PrescriptionAvailabilityTag/PrescriptionAvailabilityTagContainer.js';

const SunglassesTags = ()=>/*#__PURE__*/ React__default.createElement("div", {
        className: "sunglasses-tags"
    }, /*#__PURE__*/ React__default.createElement(ProductTag, null), /*#__PURE__*/ React__default.createElement(PrescriptionAvailabilityTagContainer, null))
;

export { SunglassesTags };
//# sourceMappingURL=SunglassesTags.js.map
